import { useState } from "react";

let unique = -1;

const Checkbox = (props:any) => {
	const [checked, setChecked] = useState(props.checked);
	const [id,] = useState(props.id ?? `checkbox${unique--}`);

	return <label>
		{ props.label }
		<div className="switch small">
			<input className="switch-input"
				id={id}
				type="checkbox"
				name={props.name}
				value={ props.value ?? ''}
				disabled={props.disabled ?? false}
				checked={ props.controlled ? props.checked : (checked ?? false) }
				onChange={(event) => {
					if(props.controlled) {
						return;
					}

					const isChecked = event.target.checked

					if(props.onChange) {
						props.onChange(isChecked)
					}

					setChecked(isChecked);
				}}
				onClick={(event:any) => {
					if(props.onClick) {
						props.onClick(event.target?.checked)
					}
				}}
			/>
			<label
				className="switch-paddle"
				htmlFor={ id }
			>
				<span
					className="switch-active"
					aria-hidden="true"
				/>
				<span
					className="switch-inactive"
					aria-hidden="true"
				/>
			</label>
		</div>
  </label>
}

export default Checkbox;
